/**
 * Where a reader's menu photo was taken, from the photo's own EXIF — read in the browser
 * from the ORIGINAL file, because the client downscale (canvas re-encode) and the server
 * re-encode both drop metadata. Often absent: phone pickers may strip location before the
 * page ever sees the file. Client-supplied, so it can only ever add caution or confidence
 * to a photo, never stand in for the photo itself.
 */
export interface EvidenceGps {
  lat: number;
  lng: number;
}

export function parseEvidenceGps(value: unknown): EvidenceGps | null {
  if (!value || typeof value !== "object") return null;
  const { lat, lng } = value as { lat?: unknown; lng?: unknown };
  if (typeof lat !== "number" || typeof lng !== "number") return null;
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  // Null Island: a camera with no fix writes 0,0.
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
}

export function distanceMeters(a: EvidenceGps, b: EvidenceGps): number {
  const R = 6_371_000;
  const rad = (d: number) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}
